// extracted by mini-css-extract-plugin
export var alignToTop = "subnav-modal-module--alignToTop--48DEa";
export var fadeIn = "subnav-modal-module--fadeIn--NZV7k";
export var subNavFadeIn = "subnav-modal-module--subNavFadeIn--aARzV";
export var subNavModal = "subnav-modal-module--subNavModal--hyNsk";